<div class="filter-container">
  <div class="buttons-wrapper" #buttonsWrapper>
    <button
      #filterButton
      *ngFor="let state of states; let i = index"
      [id]="'filter-button-' + i"  class="filter-button"
      (click)="selectFilter(i, state.value)"
      [ngClass]="{ 'selected': selectedFilterIndex === i }">
      <span>{{ state.key | translate }}</span>
    </button>
  </div>
  <div class="indicator" #indicator [ngClass]="{'not-initialized': !isInitialized}"></div>
</div>